export default () => ({
  token: '',
  user_id: '',
  rol:''
});
